import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-6" data-testid="payment-cancel">
      <div className="max-w-md w-full border border-border rounded-md bg-white p-8 text-center">
        <XCircle className="w-12 h-12 text-muted-foreground mx-auto mb-4" />
        <h1 className="font-heading font-black text-2xl text-sapphire">Payment cancelled</h1>
        <p className="text-muted-foreground text-sm mt-2">No charge was made. You can pay the job anytime from the pipeline.</p>
        <Button className="bg-ocean hover:bg-ocean/90 mt-6" onClick={() => navigate("/pm/jobs")} data-testid="back-to-jobs">Back to Jobs</Button>
      </div>
    </div>
  );
}
